import { Tooltip, TooltipProps } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { TooltipIcon } from 'app/components/Core';
import { SCROLLBAR_WIDTH_PX } from 'app/constants';

export type HelpTooltipProps = Omit<TooltipProps, 'children'>;

export const HelpTooltip = ({ label, ...rest }: HelpTooltipProps) => {
  // Control when tooltip is shown to fix touch functionality if tooltip was already touched
  const [isLabelOpen, setIsLabelOpen] = useState(false);

  // Close tooltip if mobile devices orientation has changed (tooltip position change)
  useEffect(() => {
    const handleOrientationchange = () => {
      setIsLabelOpen(false);
    };

    window.addEventListener('orientationchange', handleOrientationchange);
    return () => {
      window.removeEventListener('orientationchange', handleOrientationchange);
    };
  }, []);

  return (
    <Tooltip
      hasArrow
      label={label}
      offset={[0, -8]}
      modifiers={[
        {
          name: 'preventOverflow',
          options: {
            padding: SCROLLBAR_WIDTH_PX,
          },
        },
      ]}
      isOpen={isLabelOpen}
      {...rest}
    >
      <TooltipIcon
        tabIndex={0}
        padding={4}
        h="52px"
        onMouseEnter={() => setIsLabelOpen(true)}
        onMouseLeave={() => setIsLabelOpen(false)}
        onClick={() => setIsLabelOpen(!isLabelOpen)}
      />
    </Tooltip>
  );
};
